import React from 'react';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import Btn from 'components/Btn';
import Div from 'lib/Div';
import P from 'lib/P';
import {styles} from '../styles';
import {SummaryLine} from '../types';

type Props = {
  cardBrandLabel: string, depositAmountLabel: string, formError: string, isSubmittingDeposit: boolean,
  reviewLines: SummaryLine[], reviewTotal: SummaryLine, onSubmit: () => void, onCancel: () => void
};

const renderSummaryLine = (line: SummaryLine) => (
  <Div key={line.label} row justifyContent="space-between" alignItems="center" gap={12} py={12} borderBottomWidth={1}
       borderColor="rgba(235, 255, 247, 0.08)">
    <P fontFamily="POI Aeronaut" fs={13} lh={19.5} color="#97a8a6" flex={1}>{line.label}</P>
    <P fontFamily="POI Aeronaut" fs={14} lh={21} color="#ffffff" ta="right" fontVariant={['tabular-nums']}
       style={styles.mediumText}>
      {line.value}
    </P>
  </Div>
);

const DepositReviewStep = (props: Props) => {
  const {cardBrandLabel, depositAmountLabel, formError, isSubmittingDeposit, reviewLines, reviewTotal} = props;

  return (
    <Div gap={24}>
      <Div row alignItems="center" gap={12} bg="#0a1c1c" borderWidth={1} borderColor="rgba(39, 233, 166, 0.2)"
           rounded={14} py={14} px={16}>
        <Div w={40} h={40} rounded={999} bg="rgba(39, 233, 166, 0.1)" alignItems="center" justifyContent="center"
             flexShrink={0}>
          <MaterialIcons name="bolt" size={20} color="#27e9a6"/>
        </Div>

        <Div flex={1}>
          <P fontFamily="POI Aeronaut" fs={14} lh={21} color="#ffffff" style={styles.mediumText}>
            Funds available instantly
          </P>
          <P fontFamily="POI Aeronaut" fs={12} lh={18} color="#97a8a6" mt={2}>Pay with {cardBrandLabel}</P>
        </Div>
      </Div>

      <Div bg="#143030" borderWidth={1} borderColor="rgba(235, 255, 247, 0.08)" rounded={16} px={18} py={4}>
        {reviewLines.map(renderSummaryLine)}

        <Div row justifyContent="space-between" alignItems="center" gap={12} mt={2} pt={14} pb={12}
             borderTopWidth={1} borderColor="rgba(235, 255, 247, 0.16)">
          <P fontFamily="POI Aeronaut" fs={13} lh={19.5} color="#ffffff" flex={1} style={styles.mediumText}>
            {reviewTotal.label}
          </P>
          <P fontFamily="POI Orbiter" fs={20} lh={30} color="#27e9a6" ta="right" fontVariant={['tabular-nums']}
             style={styles.boldText}>
            {reviewTotal.value}
          </P>
        </Div>
      </Div>

      <P fontFamily="POI Aeronaut" fs={13} lh={18.2} color="#97a8a6">
        Funds appear in your Evenplay Wallet immediately. The charge shows on your statement as{' '}
        <P fontFamily="POI Aeronaut" fs={13} lh={18.2} color="#ffffff">EVENPLAY*WALLET</P>.
      </P>

      {!!formError && <P fontFamily="POI Aeronaut" fs={13} lh={18.2} color="#ff6969">{formError}</P>}

      <Div gap={10}>
        <Btn h={52} w="100%" px={28} rounded={999} bg="#27e9a6" alignItems="center" justifyContent="center"
             onPress={props.onSubmit} disabled={isSubmittingDeposit} opacity={isSubmittingDeposit ? 0.65 : 1}
             accessibilityRole="button">
          <P fontFamily="POI Aeronaut" fs={14} lh={21} ls={0.84} tt="uppercase" color="#1b3131"
             style={styles.mediumText}>
            {isSubmittingDeposit ? 'Processing...' : `Deposit ${depositAmountLabel}`}
          </P>
        </Btn>

        <Btn h={52} w="100%" px={28} rounded={999} bg="transparent" alignItems="center" justifyContent="center"
             onPress={props.onCancel} disabled={isSubmittingDeposit} accessibilityRole="button">
          <P fontFamily="POI Aeronaut" fs={14} lh={21} ls={0.84} tt="uppercase" color="#27e9a6"
             style={styles.mediumText}>
            Cancel
          </P>
        </Btn>
      </Div>
    </Div>
  );
}

export default DepositReviewStep;
